<template>
  <form v-if="form" class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">LOGOWANIE</h5>
      </div>
      <div class="modal-body">
        <div v-if="form" class="form-group">
          <label for="email" class="form-label">Login</label>
          <input
            id="email"
            name="email"
            class="form-input"
            type="email"
            required
            v-model="form.email.value"
            @blur="validateField($event, form.email)"
          />
          <span class="invalid-feedback" v-if="form.email.errors.required">Email nie może być pusty</span>
          <span
            class="invalid-feedback"
            v-if="form.email.errors.custom"
          >Nieprawidłowy login lub hasło</span>
        </div>

        <div v-if="form" class="form-group">
          <label for="password" class="form-label">Hasło</label>
          <input
            id="password"
            class="form-input"
            type="password"
            name="password"
            required
            v-model="form.password.value"
            @blur="validateField($event, form.password)"
          />
          <span
            class="invalid-feedback"
            v-if="form.password.errors.required"
          >Hasło nie może być puste</span>
        </div>
      </div>
      <div v-if="!submitted" class="modal-footer">
        <button class="form-button" :disabled="!submittable" @click="submit" right>ZALOGUJ</button>
        <div class="restore-link">
          <router-link :to="{name: 'userRestorePassword'}">Przypomnij hasło</router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script type="text/babel">
import Form from "../../form/src/Form";

export default {
  data() {
    return {
      form: Form.build({ email: "", password: "" }),
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),

    async submit(evt) {
      let user = this.validateForm(evt, this.form);
      if (user) {
        try {
          this.progress = true;
          this.submitted = true;
          await this.$store.dispatch("user/signin", user);
          this.progress = false;
          this.submitted = false;
          this.$router.replace({ name: "welcomePage" });
        } catch (e) {
          this.setCustomError(this.form.email);
          this.progress = false;
          this.submitted = false;
          console.log(e);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/src/SignPage.vue